"use client";

import PropTypes from "prop-types";
import { createContext, useContext, useState } from "react";
import Cookies from "js-cookie";

const CookieContext = createContext();

export function CookieProvider({ children }) {
  const [isOptedOut, setOptedOut] = useState(
    Cookies.get("user_opted_out") === "true"
  );

  const cookieOptions = {
    expires: 365 * 10,
    secure: true,
    sameSite: "lax",
    domain: ".appsignal.com",
  };

  const handleOptOut = () => {
    isOptedOut
      ? Cookies.set("user_opted_out", "false", cookieOptions)
      : Cookies.set("user_opted_out", "true", cookieOptions);

    setOptedOut(!isOptedOut);
  };

  const contextValue = {
    handleOptOut,
    isOptedOut,
  };

  return (
    <CookieContext.Provider value={contextValue}>
      {children}
    </CookieContext.Provider>
  );
}

export function useCookieContext() {
  return useContext(CookieContext);
}

CookieProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
};
